import React, { memo } from "react";
import cls from "classnames";

// 纯色图标 项目链接 https://www.iconfont.cn/manage/index?manage_type=myprojects&projectId=3233211
// 彩色图标 项目链接 https://www.iconfont.cn/manage/index?manage_type=myprojects&projectId=3252012

interface Props extends React.HTMLAttributes<HTMLSpanElement | HTMLOrSVGElement> {
  /**
   * icon 名称
   */
  name: string;
  /**
   * 是否彩色图标
   */
  colorful?: boolean;
}

/**
 * Iconfont 彩色图标记得加 colorful
 * @param props
 * @returns
 */
const Iconfont: React.FC<Props> = (props) => {
  const { colorful, name, className, ...others } = props;
  return name ? (
    colorful ? (
      <svg className={cls("iconfont2", className)} {...others} aria-hidden="true">
        <use xlinkHref={`#icon-${name}`}></use>
      </svg>
    ) : (
      <span className={cls("iconfont", `icon-${name}`, className)} {...others} />
    )
  ) : null;
};

export default memo<Props>(Iconfont);
